// export const BOOKS_API_BASE_ADDRESS = 'http://localhost:3001';
// export const BOOKS_ENDPOINT = 'books';
export const BOOKS_ENDPOINT = 'books';
export const BOOKS_API_BASE_ADDRESS = 'https://my-json-server.typicode.com/dzsilkov/data/';



// const res = await axios.get('https://my-json-server.typicode.com/dzsilkov/data/items/?_page=1&_limit=8');
